const MobileViewNotAvailable = () => {
    return (<div className="w-full h-80 py-5 flex justify-center items-center">
        <h1 className="text-lg mx-3">This page is not available on mobile devices. Please use a desktop/laptop to access this page</h1>
    </div>);
}
 
export default MobileViewNotAvailable;